import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
  CarriersConfiguration,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.config}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/configuration/transport`;

export interface SetSellerConfigurationTransportCommandArgs {
  sellerId: string;
  insuranceThreshold?: {
    amount: number;
    currency: string;
  } | null;
  carriersOptIn?: CarriersConfiguration<boolean> | null;
  deductTransportFromRefund?: boolean | null;
  carriersLabelsExpirationDelayInDays?: CarriersConfiguration<number>;
}

export default async function setSellerConfigurationTransportCommand(
  payload: SetSellerConfigurationTransportCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> {
  try {
    const { sellerId, ...json } = payload;
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    return await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.POST,
      json,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
